// extracted by mini-css-extract-plugin
export default {"cockpit__header":"Cockpit_cockpit__header__uAFCV","cockpit__header__h1":"Cockpit_cockpit__header__h1__iRPpv","cockpit__header__p":"Cockpit_cockpit__header__p__4sCZb"};